// extracted by mini-css-extract-plugin
export default {"modalContainer":"vx0EMT"};